export const articleCategories = [
  { id: "all", name: "全部" },
  { id: "product", name: "产品动态" },
  { id: "knowledge", name: "梨果知识" },
  { id: "recipe", name: "美食食谱" },
  { id: "health", name: "健康养生" },
  { id: "brand", name: "品牌故事" },
];

export const articlesData = [
  {
    id: "article-1",
    title: "惠美梨2026年翠冠梨新鲜上市，首批预售火爆开启",
    excerpt: "盛夏七月，惠美梨翠冠梨迎来丰收季。得益于今年充沛的雨水和充足的日照，本季翠冠梨品质再创新高，单果均重突破300g，含糖量达14%以上。首批预售已突破5万单，市场反响热烈。",
    content: `<p>盛夏七月，骄阳似火，惠美梨自营果园内一派繁忙景象。经过一整年的精心培育，翠冠梨迎来了丰收的季节。清晨五点，果农们便开始了一天的工作，一颗颗饱满圆润的翠冠梨被小心翼翼地采摘下来，装入特制的防震周转箱中。</p>
    <p>"今年的翠冠梨品质特别好，"果园技术负责人老张捧着一颗翠冠梨，脸上洋溢着丰收的喜悦，"你看这个头，比去年足足大了两圈，色泽也更漂亮。"</p>
    <p>据惠美梨品控部门检测数据显示，2026年翠冠梨平均单果重量达到312g，较去年增长8.5%；平均含糖量达到14.2%，较去年提升1.3个百分点；果肉石细胞含量进一步降低，口感更加细腻无渣。</p>
    <p>今年翠冠梨品质大幅提升，得益于三个方面的改进：一是全面升级了水肥一体化智能灌溉系统，实现了精准施肥；二是引入了蜜蜂授粉技术，显著提高了坐果率和果实均匀度；三是优化了疏花疏果方案，确保每棵梨树的营养供给更加集中。</p>
    <p>惠美梨2026年翠冠梨首批预售已于7月10日正式开启，截至7月15日，预售订单已突破5万单。惠美梨品牌负责人表示："感谢广大消费者对惠美梨的厚爱，我们将一如既往地坚持品质路线，让每一颗惠美梨都经得起品鉴。"</p>
    <p>目前，翠冠梨正按照订单顺序陆续发货，通过全程冷链配送，确保消费者收到的每一颗梨都新鲜如初。尚未下单的朋友可前往惠美梨微信小程序商城选购，新用户首单还可享受9折优惠。</p>`,
    date: "2026-07-15",
    category: "product",
    imageSeq: "article-cuiguan-2026",
    author: "惠美梨编辑部",
    readTime: "5分钟",
  },
  {
    id: "article-2",
    title: "惠美梨荣获2026年中国优质农产品金奖",
    excerpt: "在刚刚落幕的2026年中国优质农产品博览会上，惠美梨黄花梨品种凭借卓越品质脱颖而出，荣获金奖殊荣，这是对惠美梨坚持品质路线的最好肯定。",
    content: `<p>6月28日，2026年中国优质农产品博览会在杭州圆满落幕。惠美梨选送的黄花梨品种在近千个参评产品中脱颖而出，荣获本届博览会金奖，成为全场瞩目的焦点。</p>
    <p>本次博览会由中国农产品流通协会主办，吸引了来自全国30多个省市的800余家农业企业参展。评审专家组由国内知名农业院校教授、行业专家和资深品鉴师组成，从外观、口感、营养成分、安全性等多个维度对参评产品进行综合评定。</p>
    <p>"惠美梨黄花梨的评审结果是全票通过，"评审组组长、中国农业大学李教授在颁奖仪式上表示，"这个品种无论是外观品相还是内在品质，都代表了当前国内梨果种植的最高水平。金黄色的果皮、饱满的果形、浓郁的香气、酥脆的口感，每一项指标都堪称完美。"</p>
    <p>惠美梨品牌创始人表示："这个金奖是对惠美梨三十年如一日坚持品质的最好肯定。从最初的几十亩果园发展到现在的五千亩自有基地，我们始终坚持'品质优先'的核心理念。未来我们将继续加大科技投入，为消费者带来更优质的梨果产品。"</p>
    <p>据悉，惠美梨已连续三年在中国优质农产品博览会上斩获奖项，2024年获得银奖，2025年和2026年连续两年获得金奖，充分展现了惠美梨品牌持续提升的产品力和品牌影响力。</p>`,
    date: "2026-06-28",
    category: "brand",
    imageSeq: "article-award-2026",
    author: "惠美梨编辑部",
    readTime: "4分钟",
  },
  {
    id: "article-3",
    title: "梨果的营养价值与健康功效全解析",
    excerpt: "梨被誉为“百果之宗”，不仅美味可口，更有着丰富的营养价值和多种健康功效。惠美梨为您全面解析梨果的营养成分与健康益处。",
    content: `<p>梨，自古就有"百果之宗"的美誉。在传统中医理论中，梨性凉味甘，入肺、胃经，具有清热润肺、生津止渴、化痰止咳的功效。现代营养学研究也证实，梨果确实是一种营养价值极高的健康水果。</p>
    <p><strong>丰富的维生素群：</strong>梨果富含维生素C、维生素K和多种B族维生素。每100g新鲜梨果含维生素C约4-6mg，有助于增强免疫力、促进胶原蛋白合成。维生素K则对骨骼健康和血液凝固功能至关重要。</p>
    <p><strong>膳食纤维的优质来源：</strong>一个中等大小的梨（约300g）含膳食纤维约6g，占每日推荐摄入量的20%以上。梨果中的膳食纤维以可溶性纤维为主，有助于促进肠道蠕动、改善消化功能、降低胆固醇水平。</p>
    <p><strong>丰富的矿物质：</strong>梨果含有钾、铜、镁、锰等多种矿物质。其中钾含量尤其突出，有助于维持正常血压水平和心血管健康。铜元素则参与红细胞生成和神经系统功能维持。</p>
    <p><strong>抗氧化物质：</strong>梨果果皮中含有丰富的黄酮类化合物和酚酸类物质，具有显著的抗氧化活性。研究表明，经常食用梨果有助于降低慢性炎症水平，对预防心血管疾病和某些类型的癌症具有积极作用。</p>
    <p>惠美梨建议：每天食用1-2个新鲜梨果，连皮食用可获得更多的膳食纤维和抗氧化物质（请确保彻底清洗）。梨果可生食、榨汁、炖煮，多种食用方式，满足不同口味需求。</p>`,
    date: "2026-06-10",
    category: "knowledge",
    imageSeq: "article-nutrition",
    author: "惠美梨营养研究中心",
    readTime: "6分钟",
  },
  {
    id: "article-4",
    title: "冰糖雪梨的三种经典做法，润肺止咳又美味",
    excerpt: "秋冬季节，一碗热腾腾的冰糖雪梨是润肺止咳的经典食疗。惠美梨教您三种不同风味的冰糖雪梨做法，简单易学，美味健康。",
    content: `<p>冰糖雪梨是一道流传千年的经典食疗方，尤其在干燥的秋冬季节，一碗温润的冰糖雪梨不仅能滋润喉咙、缓解干咳，更是暖身暖心的美味甜品。以下介绍三种经典做法，从基础款到进阶款，总有一款适合您。</p>
    <p><strong>做法一：经典冰糖雪梨（基础款）</strong><br/>食材：惠美梨雪花梨1个、冰糖20g、清水适量<br/>步骤：1）雪花梨洗净，从顶部约1/4处切开，用勺子挖去梨核；2）在梨腹中放入冰糖，盖上梨盖；3）将梨放入碗中，蒸锅上汽后隔水蒸30-40分钟，至梨肉软烂透明即可。特点：原汁原味，清甜滋润。</p>
    <p><strong>做法二：川贝冰糖雪梨（药膳款）</strong><br/>食材：惠美梨雪花梨1个、川贝粉3g、冰糖15g、枸杞少许<br/>步骤：1）梨洗净去核，将川贝粉与冰糖混合填入梨腹；2）撒入几颗枸杞，盖上梨盖；3）隔水蒸40分钟。特点：川贝增强了化痰止咳功效，适合感冒后咳嗽不止的人群。</p>
    <p><strong>做法三：桂花蜂蜜炖梨（花香款）</strong><br/>食材：惠美梨丰水梨1个、干桂花2g、蜂蜜20g、红枣3颗<br/>步骤：1）丰水梨去皮切块，红枣去核；2）将梨块、红枣放入炖盅，加水没过食材；3）小火炖煮40分钟，关火前5分钟加入干桂花；4）待稍凉后加入蜂蜜调味。特点：桂花清香与梨的甘甜完美融合，口感层次丰富。</p>`,
    date: "2026-05-25",
    category: "recipe",
    imageSeq: "article-recipe",
    author: "惠美梨美食工作室",
    readTime: "5分钟",
  },
  {
    id: "article-5",
    title: "秋季养生指南：为什么秋天要多吃梨？",
    excerpt: "秋季气候干燥，正是吃梨的最佳时节。惠美梨结合传统中医理论和现代营养学，为您详解秋季食梨的养生之道。",
    content: `<p>秋季是梨果大量上市的季节，同时也是人体最容易受"秋燥"困扰的时期。传统中医认为，秋季对应五行中的"金"，与肺脏相通，此时养生的核心在于"润燥"。梨性凉味甘，入肺经，是秋季润燥的首选食材。</p>
    <p><strong>秋燥的表现与危害：</strong>秋季气候干燥，空气中的湿度大幅下降。人体容易出现的"秋燥"症状包括：口干舌燥、咽喉不适、皮肤干燥、干咳少痰、大便干结等。如果不及时调理，秋燥还可能诱发或加重呼吸系统疾病。</p>
    <p><strong>梨的润燥机理：</strong>梨含有80%以上的水分，且这些水分属于"结合水"，能被人体缓慢吸收利用，起到持续润燥的效果。同时，梨中的果胶和多糖类物质能在口腔和咽喉黏膜表面形成一层保护膜，有效缓解干燥不适。</p>
    <p><strong>秋季食梨的最佳方式：</strong>1）早餐后1小时食用，有助于促进消化、补充水分；2）秋冬季节建议将梨稍微加热后食用，减少梨的寒凉之性，更适合脾胃虚寒者；3）搭配蜂蜜、银耳、百合等润肺食材，效果更佳。</p>
    <p>惠美梨特别推荐：秋季选择黄花梨和丰水梨品种，此时正是这两个品种的最佳赏味期，水分充足、甜度高，是润燥养生的绝佳之选。</p>`,
    date: "2026-05-08",
    category: "health",
    imageSeq: "article-autumn-health",
    author: "惠美梨养生顾问",
    readTime: "4分钟",
  },
  {
    id: "article-6",
    title: "惠美梨智能果园升级完成，科技赋能品质再提升",
    excerpt: "惠美梨投资建设的智慧农业系统全面升级完成，引入AI图像识别分选、无人机巡检、物联网环境监测等先进技术，实现从种植到分选的全链路智能化管理。",
    content: `<p>经过为期半年的建设与调试，惠美梨智慧农业系统2.0于5月20日正式上线运行。此次升级总投资超过800万元，引入了多项行业领先的智能农业技术，标志着惠美梨在科技兴农道路上迈出了坚实的一步。</p>
    <p><strong>AI图像识别分选系统：</strong>新系统采用深度学习算法，通过高速工业相机从16个角度对每一颗梨果进行全方位拍摄，在0.3秒内完成果形、色泽、表面瑕疵等多项指标的检测与分级。相比传统人工分选，分选效率提升了5倍，分选准确率达到99.5%以上。</p>
    <p><strong>无人机智能巡检：</strong>惠美梨引入了一批搭载多光谱传感器的农业无人机，可对5000亩果园进行每日自动巡检。无人机采集的数据经过AI分析后，能精准识别病虫害早期迹象、评估树体营养状况、预测各区域产量，为精准农事管理提供科学依据。</p>
    <p><strong>物联网环境监测网络：</strong>果园内布设了200余个物联网传感器节点，实时监测土壤温湿度、光照强度、降雨量、风速风向等环境参数。所有数据汇聚到云端管理平台，技术人员可通过手机APP随时查看果园状态，并及时调整灌溉、施肥等管理措施。</p>
    <p><strong>区块链溯源系统：</strong>每一批出库的惠美梨都将附带唯一的区块链溯源码，消费者扫码即可查看该批梨果从种植、施肥、采摘到分选、包装、运输的全过程信息，真正做到"从枝头到餐桌"的全程透明可追溯。</p>`,
    date: "2026-05-20",
    category: "brand",
    imageSeq: "article-tech-2026",
    author: "惠美梨编辑部",
    readTime: "5分钟",
  },
  {
    id: "article-7",
    title: "如何挑选一颗好梨？惠美梨教你三招识梨术",
    excerpt: "面对琳琅满目的梨果，如何挑选到又甜又多汁的好梨？惠美梨分享三个简单实用的挑选技巧，让您成为挑梨高手。",
    content: `<p>买梨时，你是不是也常常凭感觉随便拿？其实，挑梨是有技巧的。掌握了以下三招"识梨术"，你也能像专业人士一样，轻松挑到又甜又多汁的好梨。</p>
    <p><strong>第一招：看外观</strong><br/>好的梨果形端正、饱满匀称，没有明显的畸形或凹陷。果皮颜色均匀自然，有光泽但不刺眼。注意观察果柄——新鲜的梨果柄呈绿色或黄绿色，如果果柄干枯发黑，说明采摘时间较久。另外，梨果底部凹陷越深，通常说明成熟度越高、甜度也越高。</p>
    <p><strong>第二招：闻香气</strong><br/>成熟的优质梨果会散发出自然清新的果香。将梨靠近鼻子轻轻一嗅，如果能闻到淡淡的甜香，说明梨的成熟度和新鲜度都很好。如果闻不到任何香气，可能还未完全成熟；如果闻到发酵或酸味，则可能已经变质。</p>
    <p><strong>第三招：摸手感</strong><br/>用手指轻轻按压梨果表面，好的梨应该有一定的硬度和弹性，既不能太硬（未成熟），也不能太软（过熟或变质）。同品种中，同等大小的梨越重越好，说明水分越充足。另外，果皮摸起来应该光滑细腻，如果有明显的粗糙感或凹凸不平，品质可能不佳。</p>
    <p>当然，选择惠美梨，您就无需费心挑选了。惠美梨的每一颗梨果都经过严格的品控筛选，只有果形、色泽、甜度、重量四项达标的优质梨果，才会被贴上惠美梨的标签送到您的手中。</p>`,
    date: "2026-04-18",
    category: "knowledge",
    imageSeq: "article-pick-pear",
    author: "惠美梨品控团队",
    readTime: "4分钟",
  },
  {
    id: "article-8",
    title: "梨果创意吃法：梨香沙拉与烤梨甜品",
    excerpt: "除了直接鲜食，梨还可以做出许多创意美食。惠美梨分享两道简单又惊艳的梨果料理，让您的餐桌多一份清甜新意。",
    content: `<p>梨不仅可以直接鲜食，在烹饪中也有着令人惊喜的表现。今天惠美梨为大家带来两道创意梨果料理——清爽的梨香沙拉和温暖的烤梨甜品，一冷一热，满足不同季节的味蕾需求。</p>
    <p><strong>梨香鸡肉沙拉（2人份）</strong><br/>食材：惠美梨丰水梨1个、鸡胸肉150g、混合生菜100g、核桃仁30g、蔓越莓干20g、橄榄油2勺、柠檬汁1勺、蜂蜜1勺、盐和黑胡椒适量<br/>步骤：1）鸡胸肉用盐和黑胡椒腌制15分钟后煎熟，切薄片备用；2）丰水梨洗净去核切薄片；3）混合生菜洗净沥干铺盘；4）将鸡肉片、梨片、核桃仁、蔓越莓干依次摆放在生菜上；5）橄榄油、柠檬汁、蜂蜜混合调成沙拉汁，淋在沙拉上即可。特点：梨的清脆与鸡肉的嫩滑形成绝妙口感对比，酸甜清爽，低脂健康。</p>
    <p><strong>红酒烤梨配香草冰淇淋（2人份）</strong><br/>食材：惠美梨雪花梨2个、红葡萄酒300ml、肉桂棒1根、八角1颗、红糖30g、香草冰淇淋2球<br/>步骤：1）雪花梨去皮，保持完整，从底部挖去梨核；2）锅中倒入红酒、红糖、肉桂棒、八角，放入梨，小火煮20分钟，不时翻面；3）将煮好的梨取出放入烤盘，淋上煮梨的红酒汁；4）烤箱预热180℃，烤15分钟；5）取出烤梨装盘，搭配一球香草冰淇淋。特点：红酒的醇厚与梨的清甜交融，搭配冰凉的香草冰淇淋，冷热交替间带来极致的味觉享受。</p>`,
    date: "2026-04-05",
    category: "recipe",
    imageSeq: "article-creative-recipe",
    author: "惠美梨美食工作室",
    readTime: "4分钟",
  },
];